import { Components } from "@mui/material"

export default function BackdropTheme(): Components {
  return {
    MuiBackdrop: {
      styleOverrides: {},
    },
  }
}
